import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendMessage } from '../../../chat/actions.any';
const SendIcon = () => (React.createElement("svg", { fill: 'none', height: '18', viewBox: '0 0 24 24', width: '18', xmlns: 'http://www.w3.org/2000/svg' },
    React.createElement("path", { d: 'M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' })));
const ChatInput = () => {
    const [text, setText] = useState('');
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const handleSend = () => {
        const trimmed = text.trim();
        if (!trimmed) {
            return;
        }
        dispatch(sendMessage(trimmed, false));
        setText('');
        inputRef.current?.focus();
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };
    return (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '10px',
            padding: '12px 16px',
            borderTop: '1px solid rgba(215,175,185,0.12)',
            background: 'rgba(0,0,0,0.2)'
        } },
        React.createElement("textarea", { maxLength: 500, onChange: e => setText(e.target.value), onKeyDown: handleKeyDown, placeholder: '\u00C9crivez un message\u2026', ref: inputRef, rows: 1, style: {
                flex: 1,
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(215,175,185,0.15)',
                borderRadius: '12px',
                color: '#EFE5DC',
                fontSize: '14px',
                lineHeight: 1.5,
                outline: 'none',
                padding: '10px 14px',
                resize: 'none',
                fontFamily: 'inherit'
            }, value: text }),
        React.createElement("button", { disabled: !text.trim(), onClick: handleSend, style: {
                alignItems: 'center',
                background: text.trim() ? '#8C4558' : 'rgba(140,69,88,0.35)',
                border: 'none',
                borderRadius: '50%',
                color: '#EFE5DC',
                cursor: text.trim() ? 'pointer' : 'default',
                display: 'flex',
                flexShrink: 0,
                height: '40px',
                justifyContent: 'center',
                transition: 'background 0.2s',
                width: '40px'
            } },
            React.createElement(SendIcon, null))));
};
export default ChatInput;
